module.exports = __webpack_public_path__ + "static/media/godaddy_output.fdc95b27.csv";